import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dropdownButton", "checkbox", "label", "enrichmentBody", "icon"]
  static values = { visible: Boolean }
  static outlets = ["credit-indicator"]

  connect() {
    this.updateButtonText()
  }

  handleCheckboxChange(event) {
    event.stopPropagation()
    this.updateButtonText()
  }

  handleRowClick(event) {
    // Prevent action if clicking directly on checkbox
    if (event.target.matches('input[type="checkbox"]')) {
      return
    }
    
    // Find the checkbox within the clicked row
    const checkbox = event.currentTarget.querySelector('input[type="checkbox"]')
    if (checkbox) {
      // Prevent default label behavior when clicking on label
      if (event.target.matches('label')) {
        event.preventDefault()
      }
      checkbox.checked = !checkbox.checked
      // Trigger change event to update the button text
      checkbox.dispatchEvent(new Event('change', { bubbles: true }))
    }
  }

  toggleEnrichmentBody() {
    if (this.visibleValue) {
      this.hideEnrichmentBody()
    } else {
      this.showEnrichmentBody()
    }
  }

  showEnrichmentBody() {
    this.enrichmentBodyTarget.classList.remove('d-none')
    this.iconTarget.classList.add('fa-rotate-180')
    this.visibleValue = true
  }

  hideEnrichmentBody() {
    this.enrichmentBodyTarget.classList.add('d-none')
    this.iconTarget.classList.remove('fa-rotate-180')
    this.visibleValue = false
  }

  updateButtonText() {
    const selectedLabels = this.getSelectedLabels()
    const buttonText = selectedLabels.length === 0
      ? "No columns selected"
      : selectedLabels.join(' · ')

    this.dropdownButtonTarget.textContent = buttonText
  }

  getSelectedLabels() {
    return this.checkboxTargets
      .filter(checkbox => checkbox.checked)
      .map(checkbox => this.findLabelForCheckbox(checkbox))
      .filter(label => label !== null)
  }

  findLabelForCheckbox(checkbox) {
    const label = this.labelTargets.find(label => label.getAttribute('for') === checkbox.id)
    return label ? label.textContent.trim() : null
  }
}
